CONTEXT_TYPE_RECENTLY_ADDED_LIST